<!-- eslint-disable max-len -->
<template>
  <v-card-text>
    <v-row>

      <v-col cols="12">
        <v-card flat style="background-color: transparent !important">
          <v-card-title class="text-body-1 font-weight-medium">How many employees (excluding owners) are on payroll?</v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Full-Time</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.employees.fullTime }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Part-Time</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.employees.partTime }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Annual Payroll</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.employees.annualPayroll }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Payroll Frequency</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.employees.payrollFrequency }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card flat style="background-color: transparent !important">
          <v-card-title class="text-body-1 font-weight-medium">How many owners are on payroll?</v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Full-Time</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.owners.fullTime }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Part-Time</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.owners.partTime }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Annual Payroll</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.owners.annualPayroll }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="4">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Payroll Frequency</v-list-item-title>
                    <v-list-item-subtitle>{{ prospectPacket.payrollInformation.owners.payrollFrequency }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'CompanyPayrollInformation',
  data: () => ({
    temp: null,
  }),
  computed: {
    prospectPacket() {
      return this.$store.state.prospectPacket;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
